export default "__VITE_ASSET__IxHNa02N__"